<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-form ref="form">
          <v-container class="py-0">
            <v-toolbar-title>{{$t('keywords.register') }}</v-toolbar-title>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <v-switch :label="$t('check.active')" v-model="objEditar.active"></v-switch>
              </v-col>

              <v-col cols="12" md="3" sm="6">
                <v-text-field
                  :readonly="isUpdating"
                  :rules="alphaNumericRules(objEditar.nameMethod)"
                  name="nameMethod"
                  :label="$t('keywords.method_name')"
                  :hint="$t('resttosoap.hint.name')"
                  v-model="objEditar.nameMethod"
                />
              </v-col>

              <v-col cols="12" md="3" sm="6">
                <HttpMethodSelect
                  v-model="objEditar.restMethod"
                  :required="true"
                  :label="$t('resttosoap.label.rest_method')"
                />
              </v-col>

              <v-col cols="12" md="3" sm="6">
                <v-text-field
                  :rules="requiredRules(objEditar.tagReturnSuccess)"
                  name="tagReturnSuccess"
                  :label="$t('resttosoap.label.tag.success')"
                  :hint="$t('resttosoap.hint.tag.success')"
                  v-model="objEditar.tagReturnSuccess"
                />
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <v-text-field
                  :rules="requiredRules(objEditar.tagReturnError)"
                  name="tagReturnError"
                  :label="$t('resttosoap.label.tag.error')"
                  :hint="$t('resttosoap.hint.tag.error')"
                  v-model="objEditar.tagReturnError"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="8">
                <v-combobox
                  v-model="chips"
                  multiple
                  chips
                  small-chips
                  clearable
                  :label="$t('keywords.url_param')"
                  :hint="$t('keywords.url_param')"
                >
                  <template v-slot:selection="{ attrs, item, select, selected }">
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      small
                      close
                      @click="select"
                      @click:close="removeChip(item)"
                    >
                      <span>{{ item }}</span>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field
                  name="returnEncoding"
                  :label="$t('keywords.encoding')"
                  v-model="objEditar.returnEncoding"
                />
              </v-col>

              <v-col cols="12" sm="3" v-if="isPlatform">
                <RoutingkeySelect v-model="objEditar.routingkey" :rules="requiredRules(objEditar.routingkey)" />
              </v-col>

              <v-col cols="12" sm="2">
                <BeansConfiguration
                  v-model="objEditar"
                  AuthorizationClassType="br.com.senior.plutaoapp.utils.process.AuthenticationExecutor"
                  AuthenticationClassType="br.com.senior.plutaoapp.utils.process.AuthenticationExecutor"
                  GenerateXmlPayloadClassType="br.com.senior.plutaoapp.resttosoap.process.GenerateXmlPayloadExecutor"
                  ProcessCallWsSoapClassType="br.com.senior.plutaoapp.resttosoap.process.ProcessCallWsSoapExecutor"
                  ProcessWsReturnClassType="br.com.senior.plutaoapp.resttosoap.process.ProcessWsReturnExecutor"
                  ReturnErrorMessageClassType="br.com.senior.plutaoapp.resttosoap.process.ReturnErrorMessageExecutor"
                />
              </v-col>
            </v-row>
            <v-expansion-panels v-model="panelsOpenned" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>XML</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="12">
                      <XMLFormatter
                        name="xmlInput"
                        label="XML"
                        v-model="objEditar.xmlInput"
                        style="font-family:Consolas,Ubuntu Mono"
                        :required="true"
                      />
                      <ReplaceInfo url-parameter json-property />
                    </v-col>
                  </v-row>
                  <v-switch :label="$t('resttosoap.label.format')" v-model="objEditar.formatXml"></v-switch>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{$t('keywords.authorization')}}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="6">
                      <AuthenticationSelect v-model="objEditar.wsAuthorizationType" :rules="requiredRules(objEditar.wsAuthorizationType)" />
                    </v-col>
                    <v-col cols="6" >
                      <v-text-field
                        v-if="objEditar.wsAuthorizationType === 'Bearer'"
                        name="wsAuthorizationToken"
                        :label="$t('keywords.authentication.token')"
                        v-model="objEditar.wsAuthorizationToken"
                      />
                      <CredentialSelect
                        v-else-if="objEditar.wsAuthorizationType === 'Basic'"
                        name="wsAuthorizationCredentialName"
                        :label="$t('resttosoap.label.authentication.credential')"
                        v-model="objEditar.wsAuthorizationCredentialName"
                        type="AUTHORIZATION_WS"
                        :required="true"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header v-text="$t('resttosoap.label.authentication.soap')" />
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        name="wsUrl"
                        label="WS Url SOAP"
                        v-model="objEditar.wsUrl"
                        :rules="requiredRules(objEditar.wsUrl)"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <HttpMethodSelect v-model="objEditar.wsMethod" :label="$t('keywords.ws_method')" :required="true" />
                    </v-col>
                    <v-col cols="12" md="4">
                      <AuthenticationSelect v-model="objEditar.wsAuthenticationType" :rules="requiredRules(objEditar.wsAuthenticationType)" />
                    </v-col>
                  </v-row>
                  <v-row v-if="objEditar.wsAuthenticationType === 'Bearer'">
                    <v-col cols="12">
                      <v-text-field
                        name="wsAuthenticationToken"
                        label="WS Token"
                        v-model="objEditar.wsAuthenticationToken"
                      />
                    </v-col>
                  </v-row>
                  <v-row v-else-if="objEditar.wsAuthenticationType === 'Basic'">
                    <v-col cols="12">
                      <CredentialSelect
                        name="wsAuthenticationCredentialName"
                        :label="$t('resttosoap.label.authentication.credential')"
                        v-model="objEditar.wsAuthenticationCredentialName"
                        type="AUTHENTICATION_WS"
                        :required="true"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-row class="mt-5 pt-5">
      <v-col cols="12" class="text-right">
        <v-btn color="success" class="mr-0" @click="saveItem">{{ $t('button.save') }}</v-btn>
        <v-btn color="blue darken-1" text @click="close">{{ $t('button.cancel') }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/RestToSoapService'
import HttpMethodSelect from '../core/HttpMethodSelect'
import XMLFormatter from '../core/XMLFormatter'
import CredentialSelect from '../core/CredentialSelect'
import '../../utils/vkbeautify'
import { alphaNumericRules, requiredRules } from '../../utils/rules'
import LocalStorageService from '../../services/LocalStorageService'
import BeansConfiguration from '../core/BeansConfiguration.vue'
import AuthenticationSelect from '../core/AuthenticationSelect.vue'
import RoutingkeySelect from '../core/RoutingkeySelect.vue'
import ReplaceInfo from '../core/ReplaceInfo.vue'

export default {
  name: 'restToSoapForm',

  components: {
    CredentialSelect,
    HttpMethodSelect,
    XMLFormatter,
    BeansConfiguration,
    AuthenticationSelect,
    RoutingkeySelect,
    ReplaceInfo
  },

  props: {
    integrationUpdating: String
  },

  computed: {
    isPlatform () { return LocalStorageService.isPlatform() },
    chips: {
      get () {
        return this.objEditar.nameQueryParameters?.split(',') || []
      },
      set (value) {
        this.objEditar.nameQueryParameters = value.join(',')
      }
    }
  },

  data: () => ({
    alphaNumericRules,
    requiredRules,
    objEditar: {
      nameMethod: '',
      nameQueryParameters: '',
      restMethod: '',
      wsAuthorizationType: '',
      wsAuthorizationToken: '',
      wsAuthorizationCredentialName: '',
      wsAuthorizationBean: '',
      tagReturnSuccess: '',
      tagReturnError: '',
      wsUrl: '',
      wsMethod: '',
      wsAuthenticationType: '',
      wsAuthenticationToken: '',
      wsAuthenticationCredentialName: '',
      wsAuthenticationBean: '',
      wsCallExecutorBean: '',
      generateXmlPayloadExecutorBean: '',
      processCallWsSoapExecutorBean: '',
      processWsReturnExecutorBean: '',
      returnErrorMessageExecutorBean: '',
      active: true,
      routingkey: '',
      formatXml: true,
      xmlInput: '',
      returnEncoding: 'UTF-8'
    },
    isUpdating: false,
    panelsOpenned: [0]
  }),

  mounted () {
    this.loadDB()
  },

  methods: {

    xmlChange () {
    },

    removeChip (item) {
      this.chips.splice(this.chips.indexOf(item), 1)
      this.chips = [...this.chips]
    },

    loadDB () {
      if (this.integrationUpdating) {
        Servico.findById(this.integrationUpdating)
          .then(response => {
            this.isUpdating = true
            this.objEditar = response.data
          })
          .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
      }
    },

    async saveItem () {
      this.objEditar.lastModifiedBy = LocalStorageService.getUsername()
      this.objEditar.clientPrefix = LocalStorageService.getClientPrefix()

      /*
      if (this.isUpdating) {
        const responseWS = await Servico.findById(this.integrationUpdating)
        this.objEditar.routingkey = responseWS.data.routingkey
      }
      */

      if (this.$refs.form.validate()) {
        if (this.isUpdating) this.updateItem()
        else this.createItem()
      } else {
        this.$message.error(this.$t('warnings.validation.fill_required_fields'))
      }
    },

    createItem () {
      Servico.insert(this.objEditar)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    updateItem () {
      Servico.update(this.objEditar)
        .then(() => this.$emit('editItem', true, null))
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    close () {
      this.$emit('editItem', true, null)
    }
  }

}
</script>
